document.addEventListener('DOMContentLoaded', function () {
  const imageSlider = new Splide('#image-slider', {
    type: 'slide', // 全て非ループ形式に統一
    perPage: 5,
    gap: '10px',
    breakpoints: {
      768: {
        perPage: 2,
        gap: '5px',
      },
    },
  }).mount();

  document.querySelectorAll('.popup').forEach(function (popup) {
    const popupId = popup.id.split('-')[1];
    const popupSliderElement = document.getElementById('popup-slider-' + popupId);

    if (popupSliderElement) {
      new Splide(popupSliderElement, {
        type: 'slide', // 全て非ループ形式に統一
        perPage: 1,
        gap: '10px',
      }).mount();
    }

    // オーバーレイ部分のクリックイベントを追加
    popup.addEventListener('click', function (event) {
      // クリックされた場所がポップアップコンテンツ以外の場合にのみポップアップを閉じる
      if (event.target === popup) {
        closePopup(popupId);
      }
    });
  });
});

function openPopup(blockId) {
  document.getElementById('popup-' + blockId).style.display = 'block';
}

function closePopup(blockId) {
  document.getElementById('popup-' + blockId).style.display = 'none';
}
